import React from 'react'
import img1 from './images/featureImg1.webp';
import img2 from './images/featureImg2.webp';
import img3 from './images/featureImg3.webp';
import img4 from './images/featureImg4.webp';

const Wp_Feature = () => {
  const features = [
    {
      title: "Connect with your ideal audience",
      desc:
        "Answer like a human, not a script. The bot understands intent and context, remembers past chats, and completes tasks—queries, bookings, and payments—right inside WhatsApp. Complex cases hand off to a human with full context.",
      cta: "See how it works",
      img: img1,
      points: [
        "Understands intent and past chats",
        "Handles queries, bookings, payments",
        "Seamless human handoff with context"
      ]
    },
    {
      title: "Messages that land, every time",
      desc:
        "Let the bot instantly handle FAQs like pricing, orders, refunds, and appointments—day or night. It fetches answers, runs workflows (tickets, updates, payments), and involves a human only when needed.",
      cta: "Automate FAQs",
      img: img2,
      points: [
        "24/7 automated FAQs",
        "Integrates with workflows & tickets",
        "Escalates to humans only when needed"
      ]
    },
    {
      title: "Approved templates for every need",
      desc:
        "Turn conversations into checkout. Let customers browse, add to cart, apply coupons, and pay via UPI/cards/wallets—without leaving WhatsApp. Auto-send invoices and order updates to reduce drop-offs.",
      cta: "Start selling",
      img: img3,
      points: [
        "In-chat cart, coupons, and payments",
        "Auto-send invoices & receipts",
        "Reduces drop-offs with instant updates"
      ]
    },
    {
      title: "Your workflow, optimized",
      desc:
        "New inquiries are auto-captured and routed to the right rep by rules you set—region, product, workload, or SLA. Round-robin or skill-based assignment, with clear ownership and reminders to stop leakage.",
      cta: "Streamline routing",
      img: img4,
      points: [
        "Auto-routing based on rules",
        "Round-robin & skill-based assignment",
        "Ensures accountability & reminders"
      ]
    }
  ];


  return (
    <section className="py-4 position-relative"
      style={{
        overflow: 'hidden',
      }}
    >
      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{
          maxWidth: '74%',
          zIndex: 1,
          marginTop: 80
        }}
      >
        {/* Heading */}
        <div>
          <h2
            style={{
              fontSize: "2.5rem",
              fontFamily: "Inter",
              fontWeight: 700,
              color: "#242121ff",
              lineHeight: 1.2,
            }}
          >
            Key features and functionalities of
            <br />
            <span style={{ color: "#1DB954" }}>WhatsApp Broadcast</span> software
          </h2>
        </div>

        {/* Features alternating */}
        <div style={{ marginTop: 50 }}>
          {features.map((f, i) => (
            <div className={`wp-row ${i % 2 !== 0 ? 'reverse' : ''}`} key={i}>
              <div className="wp-img">
                <img src={f.img} alt={f.title} />
              </div>
              <div className="wp-content">
                <h3 className="wp-title">{f.title}</h3>
                <p className="wp-desc">{f.desc}</p>
                <ul className="wp-points">
                  {f.points?.map((pt, idx) => (
                    <li key={idx}>
                      <span className="check-icon">✔</span>
                      {pt}
                    </li>
                  ))}
                </ul>

              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .wp-row{
          display:flex; 
          align-items:center; 
          justify-content:space-between; 
          gap:48px;
          margin-bottom:80px;
        }
        .wp-row.reverse{
          flex-direction:row-reverse;
        }
        .wp-img{ 
           flex:1; 
           text-align:center; 
        }
        .wp-img img{ 
           width:100%; 
           max-width:520px; 
           border-radius:14px; 
        }
        .wp-content{ flex:1; }
        .wp-title{
          font-size:1.9rem; 
          font-weight:600; 
          font-family:Lato;
          color: #242121ff;
          line-height:1.2; 
        }
        .wp-desc{
          font-size:1.2rem; 
          font-family:Lato;
          font-weight: 400;
          line-height:1.2; 
          color: #646363ff; 
          margin:0 0 16px 0;
        }
          .wp-points {
  list-style: none;
  padding: 0;
  margin: 12px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wp-points li {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-family: Lato;
  color: #646363ff; 
  gap: 10px;
}

.wp-points .check-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #E3F2FD; 
  color: #054E91;      
  font-size: 0.9rem;
  font-weight: bold;
}

          
        @media (max-width: 900px){
          .wp-row, 
          .wp-row.reverse{ flex-direction:column; 
          text-align:left; 
          gap:24px; 
          margin-bottom:56px; 
        }
          .wp-img img{ max-width:100%; }
        }
      `}</style>
    </section>
  )
}

export default Wp_Feature